module.exports = __webpack_public_path__ + "media/images/client-firehouse-2-41431f734a2774796324e8bee49853bd.png";